import { render, staticRenderFns } from "./userCenter.vue?vue&type=template&id=2d910241&scoped=true&"
import script from "./userCenter.vue?vue&type=script&lang=ts&"
export * from "./userCenter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d910241",
  null
  
)

export default component.exports